export default __webpack_public_path__ + "44e68e10eeb03bf5c619a7f3043829be.svg";